import {
  alpha,
  IconButton,
  InputBase,
  List,
  ListItem,
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { SUPPORTED_SYMBOLS_MODAL_CONSTANTS } from '../constants';

export const StyledModalBody = styled(Stack)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(12),
  minHeight: theme.spacing(SUPPORTED_SYMBOLS_MODAL_CONSTANTS.CONTENT_HEIGHT),

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(6),
  },
}));

export const StyledHeaderRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(3),
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: 700,
}));

export const StyledSearchWrapper = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(6),
}));

export const StyledSearchInput = styled(InputBase)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.customShape.borderRadiusFull,
  padding: theme.spacing(1.5, 4),
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(14),
  maxWidth: theme.spacing(SUPPORTED_SYMBOLS_MODAL_CONSTANTS.SEARCH_MAX_WIDTH),

  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
  },

  '& .MuiInputBase-input': {
    padding: 0,

    '&::placeholder': {
      color: theme.palette.text.secondary,
      opacity: 1,
    },
  },
}));

export const StyledContentArea = styled(Stack)(({ theme }) => ({
  minHeight: theme.spacing(SUPPORTED_SYMBOLS_MODAL_CONSTANTS.CONTENT_HEIGHT),
}));

export const StyledScrollableContent = styled(Stack)(({ theme }) => ({
  maxHeight: theme.spacing(SUPPORTED_SYMBOLS_MODAL_CONSTANTS.CONTENT_HEIGHT),
  overflowY: 'auto',
  paddingRight: theme.spacing(1),
  '&::-webkit-scrollbar': {
    width: 4,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.divider,
    borderRadius: theme.customShape.borderRadiusFull,
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.divider} transparent`,
}));

export const StyledSymbolList = styled(List)({
  padding: 0,
});

export const StyledSymbolRow = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(3, 2),
}));

export const StyledSymbolInfo = styled(Stack)({
  flex: 1,
  minWidth: 0,
});

export const StyledSymbolName = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 600,
}));

export const StyledSymbolDescription = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(14),
  color: theme.palette.text.primary,
  lineHeight: 1.4,
  paddingTop: theme.spacing(1),
}));

export const StyledCloseButton = styled(IconButton)({
  padding: 0,
});

export const StyledScrollIndicator = styled(IconButton)(({ theme }) => ({
  position: 'sticky',
  bottom: theme.spacing(2),
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  alignSelf: 'center',
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.15),
  },
}));

export const StyledNoResults = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  padding: theme.spacing(8, 0),
}));
